import { IonButton, IonIcon, IonLabel, IonRow } from "@ionic/react";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../reducers/UserReducer";
import { chevronDown } from "ionicons/icons";
import { isMobile } from "react-device-detect";

interface IProps {
    date:Date
};

const WelcomeRow:FC<IProps> = ({date}) => {
    const user = useSelector(selectUser)

    const formatDate = () =>{
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric', second:undefined, timeZone: 'America/Chicago'};
        return date.toLocaleTimeString('en-US', options);
    }

    if( !user){
        return null
    }

    return <IonRow className="w-100 ion-justify-content-between">
        <div style={{margin:'1rem'}}>
            <div className="text-dark-blue font-med font-helvetica font-27pt">Welcome back, {user.first_name}</div>
            <div className="text-dark-blue font-med font-helvetica font-14pt" style={{marginTop:'1rem'}}>Your energy performance dashboard</div>
        </div>
        <div className="w-100">
            <div style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>
                <div className="text-footer-blue font-med font-helvetica font-13pt" style={isMobile ? {fontSize:'12px'} : {marginRight:'2rem'}}>Date Refreshed: {formatDate()}</div>
                <IonButton size={isMobile?'small':'default'}>
                    <IonLabel className="text-white  font-bold font-helvetica font-10pt" style={{textTransform:'none'}} >Quick Actions</IonLabel>
                    <IonIcon slot='end' src={chevronDown}/>
                </IonButton>
            </div>
        </div>
    </IonRow>
};

export default WelcomeRow;